<div class="w-full  sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
    <div  class="bg-white rounded-lg p-4">
    <!-- ##########################################################  -->
    <!-- ##########################################################  -->
    <div class="w-full">
        <!-- ##########################################################  --> 
        <div class="grid grid-cols-10">   
            <div class="col-span-8">
                <!-- ## -->
                    <h2 class="prose prose-xl">Crear Sinónimo <b> {{data.nameProduct}} </b></h2>                       
                    <h2 class="prose "><small>SKU <b>{{data.skuProduct}} </b></small>  </h2>   
                <!-- ## -->
            </div>
            <div class="col-span-1">
                <!-- ## -->
                <button class="close " mat-button (click)="closeBtn()"> <mat-icon>close</mat-icon></button>    
                <!-- ## -->
            </div>
        </div>
        <!-- ##########################################################  -->    

    </div>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
    <mat-divider class="py-2"></mat-divider>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
    <form [formGroup]="externalForm" class="w-full" >

        <div class="grid grid-cols-1"> 
                    <mat-form-field class="w-full">
                        <mat-label> Sinónimo </mat-label>
                    <!-- <input matInput placeholder="Nombre del producto"  formControlName="link" />-->  

                            <input matInput type="text" placeholder="Ingrese Sinónimo" formControlName="synonym" maxlength="90"  (keydown)="this.removeSpecialCharacters($event)"/>

                    </mat-form-field>
        </div>
        <button mat-flat-button [color]="'primary'" (click)="addSynonym()" [disabled]="externalForm.invalid "> 
            Crear 
        </button>
    </form>
    <!-- ##########################################################  -->
    <!-- ##########################################################  -->
    </div>
</div>        